<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-20 11:53:22
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:29:56
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <mrc_ess_iconGroup
      :is_disabled="readonly"
      :showEdit="hasBtn('edit-platform-password-policy')"
      :showReturn="false"
      :show_del="false"
      @handleEdit="handleEdit"
    ></mrc_ess_iconGroup>

    <v-card>
      <v-card-text>
        <div class="text-h5 text--secondary mt-4">
          {{ $t("label_Password_strength_options") }}
        </div>
        <div
          style="border: 2px solid #eeeef0; border-radius: 8px"
          class="pl-7 pt-4 mt-5 dvbox"
        >
          <v-checkbox
            v-model="list.security_upper"
            color="primary"
            :readonly="readonly"
            :true-value="1"
            :false-value="0"
            :label="$t('label_The_capital_letters')"
          >
          </v-checkbox>
          <v-checkbox
            v-model="list.security_lower"
            :label="$t('label_Lowercase_letters')"
            :readonly="readonly"
            :true-value="1"
            :false-value="0"
            color="primary"
          ></v-checkbox>
          <v-checkbox
            v-model="list.security_number"
            :label="$t('label_digital')"
            :true-value="1"
            :false-value="0"
            :readonly="readonly"
            color="primary"
          ></v-checkbox>
          <v-checkbox
            v-model="list.security_other"
            :label="$t('label_Other_characters')"
            :true-value="1"
            :false-value="0"
            :readonly="readonly"
            color="primary"
          ></v-checkbox>
          <div class="d-flex">
            <v-checkbox
              v-model="list.security_password"
              :true-value="1"
              :label="$t('label_Password_length')"
              :false-value="0"
              :readonly="readonly"
              color="primary"
            >
            </v-checkbox>
            <mrc_ess_NumInput
              height="40"
              :valueLength="false"
              maxLength="6"
              class="mt-n6 mx-2"
              :style="{ width: readonly ? '64px' : '128px' }"
              v-model="list.security_password_length"
              :readonly="readonly"
            ></mrc_ess_NumInput>
            <div style="font-size: 16px; height: 32px; line-height: 45px">
              {{ $t("label_position") }}
            </div>
          </div>
        </div>

        <div class="mt-9 text-h5 text--secondary">
          {{ $t("label_Password_security_options_Settings") }}
        </div>
        <div
          style="border: 2px solid #eeeef0; border-radius: 8px"
          class="pt-3 mt-5 dvbox"
        >
          <div class="d-flex rowbox">
            <v-checkbox
              v-model="list.security_update_frequency"
              :true-value="1"
              :false-value="0"
              :label="$t('label_every')"
              :readonly="readonly"
              color="primary"
            >
            </v-checkbox>
            <mrc_ess_NumInput
              height="40"
              class="mt-n6 mx-2"
              :valueLength="false"
              maxLength="6"
              :style="{ width: readonly ? '64px' : '128px' }"
              v-model="list.security_update_frequency_day"
              :readonly="readonly"
            ></mrc_ess_NumInput>
            <div style="font-size: 16px; height: 32px; line-height: 45px">
              {{ $t("label_dayUpdatePassword") }}
            </div>
          </div>
          <div class="rowbox mt-3">
            <v-checkbox
              v-model="list.security_repeate_history_password"
              color="primary"
              :label="$t('label_Allows_the_reuse_of_historical_passwords')"
              :true-value="1"
              :false-value="0"
              :readonly="readonly"
            >
            </v-checkbox>
          </div>
          <div class="rowbox d-flex flex-column">
            <!-- <span>{{
              $t(
                'label_How_many_minutes_does_it_take_to_lock_out_an_account_by_continuously_typing_the_wrong_password'
              )
            }}</span>
            <span class="mb-3">
              <v-icon>x</v-icon>
              {{
                $t(
                  'label_Permanent_lock_requires_me_to_notify_the_administrator_to_remove_or_the_initial_password'
                )
              }}
            </span> -->
            <div class="py-4 tableBoxComponent">
              <!-- table -->
              <v-data-table
                :headers="headers"
                :items="desserts"
                hide-default-footer
              >
                <template v-slot:no-data>
                  <mrc_ess_noContent :no_data_text="$t('label_blank')" />
                </template>
                <template v-slot:item.error_number_start="{ item }">
                  <div class="d-flex">
                    <!-- <mrc_ess_NumInput height='32'
                                      textAlign='center'
                                      :style="{width:readonly?'50px':'153px'}"
                                      v-model="item.error_number_start"
                                      label=' '
                                      :readonly='readonly'></mrc_ess_NumInput>
                    <span style="height: 30px;line-height:30px;display:block"
                          class="gray--text">{{$t('label_to')}}</span> -->
                    <mrc_ess_NumInput
                      height="40"
                      :valueLength="false"
                      maxLength="6"
                      class="mx-2"
                      textAlign="center"
                      :style="{ width: readonly ? '50px' : '153px' }"
                      v-model="item.error_number_end"
                      :readonly="readonly"
                    ></mrc_ess_NumInput>
                  </div>
                </template>
                <template v-slot:item.lock_type_uuid="{ item }">
                  <mrc_ess_dictName
                    v-model="item.lock_type_uuid"
                    :disabled="readonly"
                    :chips="false"
                    :select_arr="lock_type"
                  ></mrc_ess_dictName>
                </template>
                <template v-slot:item.lock_time_minutes="{ item }">
                  <div class="d-flex align-center">
                    <mrc_ess_NumInput
                      height="40"
                      class="mx-2"
                      :valueLength="false"
                      maxLength="6"
                      textAlign="center"
                      :style="{ width: readonly ? '50px' : '153px' }"
                      v-model="item.lock_time_minutes"
                      :readonly="readonly"
                    ></mrc_ess_NumInput>
                    <div
                      style="font-size: 16px; height: 32px; line-height: 32px"
                    >
                      {{ $t("label_minutes") }}
                    </div>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }" v-if="!readonly">
                  <!-- <div @click="delOne(item)">{{ $t('label_delete') }}</div> -->
                  <v-btn depressed icon rounded @click="delOne(item)">
                    <v-icon> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <template v-if="!readonly" v-slot:footer>
                  <v-divider></v-divider>
                  <mrc_ess_textAddBtn
                    @click="addOne"
                    :rounded="false"
                    depressed
                    :text="$t('label_addOne')"
                  ></mrc_ess_textAddBtn>
                </template>
              </v-data-table>
            </div>
          </div>
          <div style="width: 100%; padding: 0 28px; margin-top: 12px">
            <v-checkbox
              v-model="noticeAdmin"
              :label="
                $t(
                  'label_Notify_the_administrator_when_the_configuration_password_is_reset'
                )
              "
              color="primary"
              :true-value="1"
              @change="noticeAdminChange"
              :false-value="0"
              :readonly="readonly"
            >
            </v-checkbox>
            <div class="pl-8">
              <v-checkbox
                v-model="list.security_notice_email"
                :label="$t('label_Notify_by_mail')"
                :readonly="readonly || !Boolean(noticeAdmin)"
                :true-value="1"
                :false-value="0"
                color="primary"
              >
              </v-checkbox>
              <!-- <v-checkbox v-model="list.security_notice_message"
                          :label="$t('label_Notify_with_a_system_message')"
                          color="primary"
                          :true-value="1"
                          :false-value="0"
                          :readonly="readonly || !Boolean(noticeAdmin)">
              </v-checkbox> -->
            </div>
          </div>
        </div>
      </v-card-text>
      <mrc_ess_submitBtn
        @cancel="cancel"
        v-if="!readonly"
        @success="success"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  showPasswordIntensity,
  updatePasswordIntensity,
} from "@/service/api/passwordIntensite";

import { get_dict_name } from "@/service/api/data_dictionary";
export default {
  components: {},
  props: {},
  data() {
    return {
      skeletonloading: true,
      searchValue: "xaxa",
      number: 1,
      readonly: false,
      list: {
        uuid: "",
        org_level_uuid: "",
        security_id: "",
        security_upper: 0, //是否大写字母
        security_lower: 0, //是否小写字母
        security_number: 0, //是否数字
        security_other: 0, //是否其他字母
        security_password: 0, //是否需要密码长度
        security_password_length: 0, //密码长度位数
        security_update_frequency: 0, //是否密码更新频率 1是 0否
        security_update_frequency_day: 0, //	密码更新频率天数
        security_repeate_history_password: 0, //是否允许重用历史密码
        security_notice_email: 0, //是否以邮件通知管理员 1是 0否
        security_notice_message: 0, //是否以消息通知管理员 1是 0否
      },
      noticeAdmin: 1,
      delDesserts: [],
      desserts: [],
      lock_type: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_Wrong_number"),
          align: "start",
          value: "error_number_start",
          sortable: false,
        },
        {
          text:
            this.$t("label_For_the_time_being") +
            "/" +
            this.$t("label_permanent"),
          sortable: false,
          value: "lock_type_uuid",
        },
        {
          text: this.$t("label_Locking_time"),
          value: "lock_time_minutes",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
  },
  created() {},
  watch: {},
  async mounted() {
    this.skeletonloading = true;
    this.readonly = this.$store.state.iconstatus;
    await this.getLock_type_uuid();
    await this.getPasswordIntensity();
    this.skeletonloading = false;
    // await this.national('mrbase_sys_dict')
    // console.log(this.national_fields)
  },

  methods: {
    addOne() {
      this.desserts.push({
        error_number_end: 3,
        lock_time_minutes: 1,
        lock_type_uuid: "temporary",
      });
    },
    delOne(item) {
      const index = this.desserts.indexOf(item);
      if (item.uuid) {
        this.delDesserts.push(Object.assign({}, item, { "~type~": "del" }));
      }
      this.desserts.splice(index, 1);
    },
    async getLock_type_uuid() {
      const res = await get_dict_name({ dict_name: "lock_type" });
      if (res.code == 200) {
        this.lock_type = res.data;
      }
    },
    async getPasswordIntensity() {
      this.skeletonloading = true;
      const res = await showPasswordIntensity({
        org_level_uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        const {
          uuid,
          // security_uuid,
          // security_id,
          // org_level_uuid,
          security_upper, //是否大写字母
          security_lower, //是否小写字母
          security_number, //是否数字
          security_other, //是否其他字母
          security_password, //是否需要密码长度
          security_password_length, //密码长度位数
          security_update_frequency, //是否密码更新频率 1是 0否
          security_update_frequency_day, //	密码更新频率天数
          security_repeate_history_password, //是否允许重用历史密码
          security_notice_email, //是否以邮件通知管理员 1是 0否
          security_notice_message, //是否以消息通知管理员 1是 0否
        } = res.data;
        const list = {
          uuid,
          // security_uuid,
          // security_id,
          // org_level_uuid,
          security_upper, //是否大写字母
          security_lower, //是否小写字母
          security_number, //是否数字
          security_other, //是否其他字母
          security_password, //是否需要密码长度
          security_password_length, //密码长度位数
          security_update_frequency, //是否密码更新频率 1是 0否
          security_update_frequency_day, //	密码更新频率天数
          security_repeate_history_password, //是否允许重用历史密码
          security_notice_email, //是否以邮件通知管理员 1是 0否
          security_notice_message, //是否以消息通知管理员 1是 0否
        };
        this.list = list;
        this.desserts = res.mrbase_sys_password_security_details;
      }
      this.skeletonloading = false;
    },
    noticeAdminChange(val) {
      if (!val) {
        this.list.security_notice_message = 0;
        this.list.security_notice_email = 0;
      }
    },
    search(v) {
      // console.log('搜索点击', v)
    },
    keydown(v) {
      // console.log('回车', v)
    },
    ds() {
      // console.log(this.searchValue)
    },
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly); //行内进图标显示
    },
    cancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          this.readonly = !this.readonly;
          await this.getPasswordIntensity();
        })
        .catch((err) => {});
    },
    async success() {
      const permanent = this.desserts.some(
        (item) => item.lock_type_uuid == "permanent"
      );
      if (permanent) {
        const res = await updatePasswordIntensity({
          ...this.list,
          mrbase_sys_password_security_details: [
            ...this.desserts,
            ...this.delDesserts,
          ],
          org_level_uuid: this.$store.state.uuid,
        });
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_modification_was_successful"),
          });
          this.readonly = !this.readonly;
        }
      } else {
        this.$myConfirm({ content: this.$t("message_passwordForeverLockTips") })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
.dvbox /deep/ .v-input__control {
  padding-top: 9px;
}
.rowbox {
  border-bottom: 2px solid #eeeef0;
  width: 100%;
  padding: 0 28px;
}
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
</style>
